var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 48,
    fill: "#009e60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 48,
    fill: "#fcd116"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 48,
    fill: "#0072c6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009e60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32,34 4,8 4,-8 -4,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27,24 4,8 4,-8 -4,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37,24 4,8 4,-8 -4,-8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.56dc1f92beb71bf5373a5b82e6f050c2.svg";
export { ForwardRef as ReactComponent };